function UserDisplay(props) {
    const { bgColor, email, showEmail } = props;
    const firstName = props.firstName || "";
    const lastName = props.lastName || "";
    const displayName = props.displayName || "";

    return (
        <div className="d-flex align-items-center pb-1 pt-1">
            <div className="me-2 circle" style={{ background: bgColor, }}>
                {email && email.substring(0, 2).toUpperCase()}
            </div>
            <div className="ps-2">
                <h5 className="mb-0">
                    {displayName !== "" ? displayName : firstName !== "" ? firstName + ' ' + lastName : email}
                </h5>
                {
                    showEmail && email
                }
            </div>
        </div>
    )
}

export default UserDisplay;